import { useGetList } from "ra-core";

import type { Contact, ContactNote } from "../types";
import { DashboardKpis } from "./DashboardKpis";
import { DashboardStepper } from "./DashboardStepper";
import { DealsByStage } from "./DealsByStage";
import { HotContacts } from "./HotContacts";
import { TasksList } from "./TasksList";
import { UpcomingEvents } from "./UpcomingEvents";

export const Dashboard = () => {
  const {
    data: dataContact,
    total: totalContact,
    isPending: isPendingContact,
  } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });

  const { total: totalContactNotes, isPending: isPendingContactNotes } =
    useGetList<ContactNote>("contact_notes", {
      pagination: { page: 1, perPage: 1 },
    });

  const { total: totalDeal, isPending: isPendingDeal } = useGetList<Contact>(
    "deals",
    {
      pagination: { page: 1, perPage: 1 },
    },
  );

  const isPending = isPendingContact || isPendingContactNotes || isPendingDeal;

  if (isPending) {
    return null;
  }

  if (!totalContact) {
    return <DashboardStepper step={1} />;
  }

  if (!totalContactNotes) {
    return <DashboardStepper step={2} contactId={dataContact?.[0]?.id} />;
  }

  return (
    <div className="flex flex-col gap-6 mt-4">
      <DashboardKpis />
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <div className="md:col-span-3 flex flex-col gap-6">
          <UpcomingEvents />
          <HotContacts />
        </div>
        <div className="md:col-span-6 flex flex-col gap-6">
          {totalDeal ? <DealsByStage /> : null}
        </div>
        <div className="md:col-span-3">
          <TasksList />
        </div>
      </div>
    </div>
  );
};
